import {
    Approximates,
} from './FuelMath';

export default class Ratio{

    #m_A;
    #m_B 

    constructor(a, b, percentage = false) {
        if (percentage) {
            if (a > 1 || b > 1) {
                a = a / 100;
                b = b / 100;
            }

            let sum = a + b;
            if (sum > 1.0 && !Approximates(sum, 1.0)) {
                // throw new Exception("Invalid Ratio");
                return;
            }
        }

        this.RatioBase(a, b);
    }

    get A() {
        return this.#m_A;
    }
    set A(value) {
        this.#m_A = value;
    }

    get B() {
        return this.#m_B;
    }
    set B(value) {
        this.#m_B = value;
    }

    toString() {
        return this.#m_A.toString() & ":" & this.#m_B.toString()
    }

    RatioBase(a, b) {
        if ((a < 0) || (b < 0) || (a == 0 && b == 0)) {
            throw "Invalid Ratio";
        }
        else {
            this.#m_A = a;
            this.#m_B = b;
        }
    }
}